import $ from "jquery";
import Swiper from "swiper/bundle";

export const ProgressBar = function () {
	if (!($(".progressbar").length > 0)) return false;

	const activeSlideIndex = $(".is-active").closest(".swiper-slide").index();
	
	new Swiper(".swiper-container", {
		// loop: true,
		slidesPerView: "auto",
		initialSlide: activeSlideIndex,
		freeMode: true,
		// centeredSlides: true,
		// centeredSlidesBounds: true,
		spaceBetween: 32,
		grabCursor: true,
		lazy: true,
	});

};
